"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureMessageCenter = void 0;
var event_1 = require("@tencent/ark-utils/lib/event");
var docs_login_1 = require("@tencent/docs-login");
var util_1 = require("../util");
var websocket_manager_1 = require("./websocket/websocket-manager");
var collab_room_reporter_1 = __importDefault(require("../report/collab-room-reporter"));
var ConnectMaxDelay = 20;
var ConnectMinDelay = 2;
/**
 * 非编辑消息管理中心，管理 Websocket 的消息推送后广播
 *
 * @class FeatureMessageCenter
 * @implements {IFeatureMessageCenter}
 * @implements {IFeatureMessageCenterReceiver}
 */
var FeatureMessageCenter = /** @class */ (function () {
    function FeatureMessageCenter() {
        this.onFeatureMessageEventEmitter = new event_1.Emitter();
        this.sendMessages = new Map();
        this.uid = FeatureMessageCenter.configs.uid || docs_login_1.getUid();
        var userId = FeatureMessageCenter.configs.userId || "p." + this.uid;
        this.userId = "" + userId;
        this.gtag = "main_page_" + this.userId;
        this.onFeatureMessageEvent = this.onFeatureMessageEventEmitter.event;
        collab_room_reporter_1.default.reportUserChannel();
    }
    /**
     * 配置业务参数，可配置 uid、userId 等信息
     * 非编辑 websocket 建立连接时优先使用传入参数，未配置情况下会尝试通过工具获取
     *
     * @static
     * @param {(Record<string, string | number>)} config
     */
    FeatureMessageCenter.config = function (config) {
        FeatureMessageCenter.configs = Object.assign(FeatureMessageCenter.configs, config);
    };
    /**
     * 非编辑消息管理中心单实例
     *
     * @static
     * @returns
     */
    FeatureMessageCenter.getInstance = function () {
        if (!global.featureMessageCenterInstance) {
            var featureMessageCenterInstance = new FeatureMessageCenter();
            global.featureMessageCenterInstance = featureMessageCenterInstance;
            featureMessageCenterInstance.connect();
        }
        if (!FeatureMessageCenter.instance) {
            FeatureMessageCenter.instance = global.featureMessageCenterInstance;
        }
        return FeatureMessageCenter.instance;
    };
    /**
     * 是否已经处于连接中
     *
     * @returns {boolean}
     */
    FeatureMessageCenter.prototype.isConnecting = function () {
        return !!this.socketManager;
    };
    /**
     * 业务层主动打开连接
     *
     * @returns {void}
     */
    FeatureMessageCenter.prototype.connect = function () {
        if (this.isConnecting()) {
            return;
        }
        this.websocketConnect();
    };
    /**
     * 业务层主动断开连接
     *
     * @param {string} [reason]
     */
    FeatureMessageCenter.prototype.disConnect = function (reason) {
        var _a;
        (_a = this.socketManager) === null || _a === void 0 ? void 0 : _a.disConnect(reason !== null && reason !== void 0 ? reason : '');
    };
    /**
     * 业务层销毁连接
     *
     */
    FeatureMessageCenter.prototype.dispose = function () {
        var _a;
        this.onFeatureMessageEventEmitter.dispose();
        (_a = this.socketManager) === null || _a === void 0 ? void 0 : _a.dispose();
    };
    /**
     * 连接成功后回调事件
     *
     */
    FeatureMessageCenter.prototype.onConnect = function () {
        this.sendClientReady();
    };
    FeatureMessageCenter.prototype.sendMessage = function (message) {
        var _this = this;
        var _a, _b;
        if (!message.type) {
            (_a = message.onError) === null || _a === void 0 ? void 0 : _a.call(message, new Error('type is undefined'));
            return;
        }
        var taskId = util_1.generateMessageTaskId();
        // 组装消息
        var sendingMessage = {
            uid: this.userId,
            type: message.type,
            task_id: taskId,
        };
        sendingMessage = Object.assign(sendingMessage, message);
        var messageTimer = setTimeout(function () {
            var _a;
            clearTimeout(messageTimer);
            var key = "" + taskId;
            if (_this.sendMessages.has(key)) {
                var sendMessage = _this.sendMessages.get(key);
                (_a = sendMessage === null || sendMessage === void 0 ? void 0 : sendMessage.onError) === null || _a === void 0 ? void 0 : _a.call(sendMessage, new Error('sending timeout.'));
                _this.sendMessages.delete(key);
            }
        }, message.timeout || 30 * 1000);
        this.sendMessages.set("" + taskId, message);
        (_b = this.socketManager) === null || _b === void 0 ? void 0 : _b.sendMessage(taskId + "=" + util_1.JsonUtil.jsonStringify(sendingMessage));
    };
    /**
     * 连接失败后回调事件
     *
     */
    FeatureMessageCenter.prototype.onConnectFail = function () {
        var _this = this;
        if (this.websocketDelayConnectTimer) {
            return;
        }
        this.socketManager = undefined;
        var delay = Math.max(Math.floor(Math.random() * ConnectMaxDelay), ConnectMinDelay) * 1000;
        this.websocketDelayConnectTimer = setTimeout(function () {
            _this.websocketConnect();
        }, delay);
    };
    /**
     * 收到服务器主动推送消息
     *
     * @param {string} message
     */
    FeatureMessageCenter.prototype.onGetMessageFromServerPush = function (message) {
        var _a;
        var response = util_1.JsonUtil.parseJson(message);
        var key = undefined;
        var sendMessage = undefined;
        if (response === null || response === void 0 ? void 0 : response.task_id) {
            key = "" + response.task_id;
            sendMessage = this.sendMessages.get(key);
        }
        // 全员广播
        this.onFeatureMessageEventEmitter.fire({
            data: message,
            type: sendMessage === null || sendMessage === void 0 ? void 0 : sendMessage.type,
        });
        // 有些业务发送数据后回包走的推送也要单独触发
        if (message && key && sendMessage) {
            (_a = sendMessage.onSuccess) === null || _a === void 0 ? void 0 : _a.call(sendMessage, response);
            this.sendMessages.delete(key);
        }
    };
    /**
     * Websocket 建立连接
     *
     * @private
     * @returns {void}
     */
    FeatureMessageCenter.prototype.websocketConnect = function () {
        if (!this.uid) {
            return;
        }
        this.resetWebsocketDelayConnectTimer();
        this.socketManager = new websocket_manager_1.WebsocketManager({
            userId: this.userId,
            gtag: this.gtag,
            host: window.location.host,
            featureMessageCenterReceiver: this,
        });
        this.socketManager.connect();
    };
    /**
     * 建立连接后登陆房间
     *
     * @private
     */
    FeatureMessageCenter.prototype.sendClientReady = function () {
        var _a;
        var clientReady = {
            type: "CLIENT_READY" /* CLIENT_READY */,
            uid: this.userId,
            gtag: this.gtag,
            cookie: util_1.getCookieForMessage(),
        };
        var message = util_1.generateMessageTaskId() + "=" + util_1.JsonUtil.jsonStringify(clientReady);
        (_a = this.socketManager) === null || _a === void 0 ? void 0 : _a.sendMessage(message);
    };
    FeatureMessageCenter.prototype.resetWebsocketDelayConnectTimer = function () {
        if (this.websocketDelayConnectTimer) {
            clearTimeout(this.websocketDelayConnectTimer);
            this.websocketDelayConnectTimer = 0;
        }
    };
    FeatureMessageCenter.configs = {};
    return FeatureMessageCenter;
}());
exports.FeatureMessageCenter = FeatureMessageCenter;
